/* eslint-disable @blumintinc/blumint/extract-global-constants */
import { GridColDef } from '@mui/x-data-grid';
import { ScoreOption } from 'functions/src/types/firestore/Game/Competition';
import { Rank } from './Rank';
import { Username } from './Username';
import { Score } from './Score';
import { Prize } from './Prize';
import { Qualified } from './Qualified';
import { QualificationConditions } from 'functions/src/types/firestore/Game/Tournament';
import { optionalColumns } from './optionalColumns';
import { Details } from './referee/Details';

export type rankedResultsColumnsProps = {
  scoreOption?: ScoreOption;
  resultsLength: number;
  qualification?: QualificationConditions;
  scoreOptions?: ScoreOption[];
  isRefereeView?: boolean;
};

export const rankedResultsColumns = ({
  scoreOption,
  resultsLength,
  qualification,
  scoreOptions,
  isRefereeView,
}: rankedResultsColumnsProps): GridColDef[] => {
  const prizeColumn: GridColDef = {
    field: 'prize',
    headerName: 'PRIZE',
    width: 250,
    sortable: false,
    editable: false,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row }) => {
      return <Prize prize={row.prize} rank={row.rank} />;
    },
  };

  const rankColumn: GridColDef = {
    field: 'rank',
    headerName: 'RANK',
    minWidth: 60,
    maxWidth: 100,
    flex: 1,
    sortable: false,
    editable: false,
    renderCell: ({ row }) => {
      return <Rank rank={row.rank} />;
    },
  };
  const usernameColumn: GridColDef = {
    field: 'username',
    headerName: 'USERNAME',
    minWidth: 280,
    flex: 1,
    sortable: false,
    editable: false,
    renderCell: ({ row }) => {
      return (
        <Username
          imgUrl={row.imgUrl}
          name={row.name}
          rank={row.rank}
          userIdCaptain={row.userIdCaptain}
        />
      );
    },
  };
  const detailsColumn: GridColDef = {
    field: 'details',
    headerName: 'DETAILS',
    minWidth: 600,
    maxWidth: 600,
    hideable: true,
    sortable: false,
    editable: false,
    renderCell: ({ row }) => {
      return <Details userIds={row.userIds} captainId={row.userIdCaptain} />;
    },
  };
  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const qualifiedColumn: GridColDef = {
    field: 'qualified',
    headerName: 'QUALIFIED',
    sortable: false,
    editable: false,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row }) => {
      return (
        <Qualified
          scoreValue={row.score}
          rank={row.rank}
          resultsLength={resultsLength}
          qualification={qualification}
        />
      );
    },
  };
  const scoreOptionColumn: GridColDef = {
    field: scoreOption?.name.toLowerCase() || 'score',
    headerName: scoreOption?.name.toUpperCase() || 'SCORE',
    minWidth: 130,
    maxWidth: 350,
    flex: 1,
    sortable: false,
    editable: false,
    renderCell: ({ row }) => {
      return (
        <Score
          score={String(row.score)}
          rank={row.rank}
          scoreOption={scoreOption}
        />
      );
    },
  };

  return [
    rankColumn,
    usernameColumn,
    ...(isRefereeView ? [detailsColumn] : []),
    scoreOptionColumn,
    ...optionalColumns({ scoreOptions }),
    ...(!!qualification ? [qualifiedColumn] : []),
    prizeColumn,
  ];
};
